import {createFileRoute} from '@tanstack/react-router';
import {DepositAccountPage} from 'features/deposit/pages/DepositAccountPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/deposits/$accountId/',
)({
  component: DepositAccountPage,
});
